module.exports = __webpack_public_path__ + "img/gestures_cn.7e4248e.jpg";